import { Link } from "react-router-dom";

function Message() {
    return (
        <div id="block-four" className="section py-5 py-md-4 bg-primary" style={{zIndex: 'inherit', outline: 'none'}} tabIndex="-1">
            <div className="container">
                <div className="tab-content" id="tabs-content1">
                    <div className="tab-pane fade show active" id="fourcontent-1" role="tabpanel" aria-labelledby="fournav-1">
                        <div className="row align-items-center">
                            <div className="col-12 text-center">
                                <p className="mb-0 text-white" style={{fontSize:20}}>Looking to optimize your website and mobile app?<Link className="btn btn-light ms-3 mt-4 mt-md-0" to='/Contact'>Contact Us </Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Message;